var map = {
	"./background-k5-seasonal-fall.png": 85204,
	"./background-k5-seasonal-spring.png": 1304,
	"./background-k5-seasonal-summer.png": 21616,
	"./background-k5-seasonal-winter.png": 44612
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15683;